// Merge a saved dashboard layout with the current widget registry ids.
// Saved layouts may reference widgets that no longer exist, and new
// widgets may exist that the saved layout has never seen.
// `lockedIds` are pinned: forced to the front of `order` (in registry order)
// and stripped from `hidden`, overriding whatever the saved layout says.
export function applyLayout(registryIds, saved, lockedIds = []) {
  const known = new Set(registryIds);
  const locked = new Set(lockedIds.filter((id) => known.has(id)));
  const savedOrder = Array.isArray(saved && saved.order)
    ? [...new Set(saved.order.filter((id) => known.has(id) && !locked.has(id)))]
    : [];
  const seen = new Set(savedOrder);
  const unlockedTail = registryIds.filter((id) => !seen.has(id) && !locked.has(id));
  const order = [
    ...registryIds.filter((id) => locked.has(id)),
    ...savedOrder,
    ...unlockedTail,
  ];
  const hidden = Array.isArray(saved && saved.hidden)
    ? saved.hidden.filter((id) => known.has(id) && !locked.has(id))
    : [];
  return { order, hidden };
}
